import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { atom, useRecoilState } from "recoil";
import axiosInstance from "utils/axios";
import { searchClient } from "utils/searchClient";

type Recommendation = {
  objectID: string;
  _highlightResult?: object;
  _snippetResult?: object;
  _rankingInfo?: object;
  _distinctSeqID?: number;
  id: number;
  title: string;
  images: string[];
  thumbnail: string;
  retail_price: number;
  wholesale_price: number;
};

const dataState = atom({
  key: "product-details-data",
  default: {
    loading: true,
    title: "",
    retail_price: 0,
    wholesale_price: 0,
    category: "",
    brand: "",
    sku: "",
    images: [],
    description: "",
    stock: "",
  },
});
const recommendationsState = atom<{
  loading: boolean;
  data: Recommendation[];
}>({
  key: "product-details-recommendations",
  default: {
    loading: true,
    data: [],
  },
});

export default function useFunctions() {
  const { id } = useParams();
  const navigate = useNavigate();
  // const location = useLocation();
  const [data, setData] = useRecoilState(dataState);
  const [recommendations, setRecommendations] =
    useRecoilState(recommendationsState);

  const getProductDetails = async () => {
    setData((prev) => ({ ...prev, loading: true }));
    await axiosInstance
      .get(`products?id=${id}`)
      .then((res) => {
        setData({ ...res.data, loading: false });
      })
      .catch(() => {
        navigate("/products");
      });
  };

  const getRecommendations = async () => {
    setRecommendations({ loading: true, data: [] });
    try {
      const response = await searchClient.getRecommendations([
        {
          indexName: "products",
          objectID: `${id}`,
          model: "looking-similar",
          maxRecommendations: 10,
        },
      ]);

      const hits = response.results[0]?.hits || [];
      // console.log("Recommended Products:", hits);
      //@ts-ignore
      setRecommendations({ loading: false, data: hits });
    } catch (error) {
      console.error("Error fetching recommendations:", error);
      setRecommendations({ loading: false, data: [] });
    }
  };

  const onBackClick = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (data.title) {
      getRecommendations();
    }
  }, [data]);

  return {
    loading: data.loading,
    id,
    data,
    recommendations,
    getProductDetails,
    onBackClick,
  };
}
